module.exports = {
    siteMetadata: {
        title: 'gmugart',
        siteUrl: `https://www.gmugart.com`,
    },
    plugins: ['gatsby-plugin-react-helmet', 
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    `gatsby-plugin-react-next`, 
    `gatsby-plugin-styled-jsx`, 
    'gatsby-plugin-sass', 
    `gatsby-plugin-netlify-cms`
    ,
    { 
      resolve: `gatsby-plugin-sitemap`
    } , 
    {
        resolve: `gatsby-source-filesystem`,
        options: {
            path: `${__dirname}/src/content/blog`,
            name: 'blog',
        }
    },  {
      resolve: 'gatsby-source-filesystem',
      options: {
        name: 'images',
        path: `${__dirname}/src/content/blog/images`,
      },
    },
    /*{
        resolve: `gatsby-source-filesystem`,
        options: {
            path: `${__dirname}/src/content/proyectos`,
            name: 'proyectos',
        }
    },*/ 'gatsby-transformer-remark', {
        resolve: `gatsby-transformer-remark`,
        options: {
            plugins: [`gatsby-remark-emoji`,
                `gatsby-plugin-sharp`, {
                  resolve: `gatsby-remark-relative-images`,
                },
                {
                    resolve: `gatsby-remark-images`,
                    options: {
                        maxWidth: 800,
                        showCaptions: true
                    },
        }, 
                
                {
          resolve: `gatsby-remark-prismjs`,
          options: {
            // Class prefix for <pre> tags containing syntax highlighting;
            // defaults to 'language-' (eg <pre class="language-js">).
            // If your site loads Prism into the browser at runtime,
            // (eg for use with libraries like react-live),
            // you may use this to prevent Prism from re-processing syntax.
            // This is an uncommon use-case though;
            // If you're unsure, it's best to use the default value.
            classPrefix: "language-",
            // This is used to allow setting a language for inline code
            // (i.e. single backticks) by creating a separator.
            // This separator is a string and will do no white-space
            // stripping.
            // A suggested value for English speakers is the non-ascii
            // character '›'.
            inlineCodeMarker: "±",
            // This lets you set up language aliases.  For example,
            // setting this to '{ sh: "bash" }' will let you use
            // the language "sh" which will highlight using the
            // bash highlighter.
            aliases: {},
          },
        },
        {
          resolve: "gatsby-remark-external-links",
          options: {
            target: "_blank",
            rel: "nofollow"
          }
        }
      ],
            
        },
},  {
   resolve: `@debiki/gatsby-plugin-talkyard`,
   options: {
     talkyardServerUrl: 'https://comments-demo.talkyard.io'
   }
 },  {
      resolve: `gatsby-plugin-google-analytics`,
      options: {
        trackingId: "UA-117339398-1",
        // Puts tracking script in the head instead of the body
        head: true,
        // Setting this parameter is optional
        anonymize: true,
        // Setting this parameter is also optional
        respectDNT: true,
      },
    }, {
    resolve: `gatsby-plugin-google-tagmanager`,
    options: {
      id: "GTM-PBF6C8L",
      // Include GTM in development.
      // Defaults to false meaning GTM will only be loaded in production.
      includeInDevelopment: true,
    },
  }, {
    resolve: 'gatsby-plugin-mailchimp',
    options: {
      endpoint: 'https://gorkamg.us12.list-manage.com/subscribe/post?u=61466ee0b86919031e5fc6e17&amp;id=856821eb83', // see instructions section below
    },
  },
 // make sure to put last in the array
 {
  resolve: `gatsby-plugin-netlify`,
  options: {
    headers: {}, // option to add more headers. `Link` headers are transformed by the below criteria
    allPageHeaders: [], // option to add headers for all pages. `Link` headers are transformed by the below criteria
    mergeSecurityHeaders: false, // boolean to turn off the default security headers
    mergeLinkHeaders: false, // boolean to turn off the default gatsby js headers
    mergeCachingHeaders: false, // boolean to turn off the default caching headers
    transformHeaders: (headers, path) => headers, // optional transform for manipulating headers under each path (e.g.sorting), etc.
    generateMatchPathRewrites: false, // boolean to turn off automatic creation of redirect rules for client only paths
  },
}],
};


// WEBPACK FOOTER //
// ./gatsby-config.js